import { RESET } from 'action-creators/generic';
import {
  I18nActions,
  CHANGE_LANGUAGE,
  LOAD_COUNTRY_LIST,
  LOADING_COUNTRIES,
  LOAD_NATIONALITY_COUNTRIES,
  LOADING_NATIONALITY_COUNTRIES,
  LOAD_REST_COUNTRIES,
  LOADING_REST_COUNTRIES,
} from 'action-creators/i18n';
import { Country, NationalityCountry } from 'models/country';
import { RestCountryResponse } from 'models/restCountry';
import { getCurrentCountry } from 'utils/generic';

export interface I18nState {
  country: Country;
  countryList: Country[];
  loadingCountries: boolean;
  nationalityCountries: NationalityCountry[];
  loadingNationalityCountries: boolean;
  restCountries: RestCountryResponse[];
  loadingRestCountries: boolean;
}

const initialState: I18nState = {
  country: getCurrentCountry(),
  countryList: [],
  loadingCountries: false,
  nationalityCountries: [],
  loadingNationalityCountries: false,
  restCountries: [],
  loadingRestCountries: false,
};

const reducer = (state = initialState, action: I18nActions): I18nState => {
  switch (action.type) {
    case CHANGE_LANGUAGE: {
      return {
        ...state,
        country: action.country,
      };
    }
    case LOAD_COUNTRY_LIST: {
      return {
        ...state,
        countryList: action.countries,
        loadingCountries: false,
      };
    }
    case LOADING_COUNTRIES: {
      return {
        ...state,
        loadingCountries: action.loading,
      };
    }
    case LOAD_NATIONALITY_COUNTRIES: {
      return {
        ...state,
        nationalityCountries: action.countries,
        loadingNationalityCountries: false,
      };
    }
    case LOADING_NATIONALITY_COUNTRIES: {
      return {
        ...state,
        loadingNationalityCountries: action.loading,
      };
    }
    case LOAD_REST_COUNTRIES: {
      return {
        ...state,
        restCountries: action.countries,
        loadingRestCountries: false,
      };
    }
    case LOADING_REST_COUNTRIES: {
      return {
        ...state,
        loadingRestCountries: action.loading,
      };
    }
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
